// import {  BellIcon, Cog6ToothIcon, HomeIcon, UsersIcon } from "@heroicons/react/16/solid";
import { FaRegBell } from "react-icons/fa";
import { HiOutlineBars4 } from "react-icons/hi2";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import BreadCrumbs from "../Components/Admin/BreadCrumbs";
import Sidebar from "../Components/Admin/Sidebar";

export default function AdminLayout() {
    // ✅ Add this line
    const user = JSON.parse(localStorage.getItem("admin_user"));
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await fetch("https://orisoftpl.com/backend/api/admin/logout", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
                },
            });
        } catch (error) {
            console.error("Logout error:", error);
        } finally {
            // Always clear localStorage and redirect, even if API call fails
            localStorage.removeItem("admin_token");
            localStorage.removeItem("admin_user");
            navigate("/admin/login");
        }
    }
    return (
        <>
            <div className="pageWrapper flex h-screen">

                <div className="page-inner flex w-full h-full">

                    {/* Sidebar */}
                    <Sidebar />

                    {/* Content */}
                    <div className="page-conternt-wrapper flex flex-col flex-1 h-full bg-[#faf8fb] ">

                        {/* Admin Header */}
                        <header className="bg-white shadow-[0px_0px_28px_rgba(0,0,0,0.13)]  px-8 h-[66px]  custFlexBetween">

                            <HiOutlineBars4 className="h-6 w-6 text-gray-500" />
                            <div className="custFlexBetween w-20">

                                <FaRegBell className="h-6 w-6 text-gray-600" />

                                <div className="dropdown dropdown-bottom dropdown-end">
                                    <div className="avatar avatar-offline" tabIndex={0} role="button">
                                        <div className="avatar">
                                            <div className=" w-8 rounded-full ">
                                                <img src="https://img.daisyui.com/images/stock/photo-1534528741775-53994a69daeb.webp" />
                                            </div>
                                        </div>
                                    </div>
                                    <ul tabIndex="0" className="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow">

                                        <li className="menu-title px-2 py-1 font-semibold text-gray-700">
                                            {user?.name || "Admin"}
                                        </li>
                                        <li><a>Profile</a></li>
                                        <li><Link onClick={handleLogout} className="text-red-500 cursor-pointer">Logout</Link></li>
                                    </ul>
                                </div>

                            </div>
                        </header>

                        {/* Content Goes Here */}
                        <main className="flex-1 overflow-auto px-8 py-6">
                            <BreadCrumbs />
                            <Outlet />
                        </main>

                    </div>

                </div>
            </div>

        </>
    );
}